export default __webpack_public_path__ + "static/media/svg2.33e03a41.svg";